/**
 * Removes duplicate strings from an array.
 */
export function uniqStrings(strings) {
  const ourSet = {};
  for (let i = 0; i < strings.length; i++) {
    ourSet[strings[i]] = null;
  }
  return Object.keys(ourSet);
}